"use strict";

// ---------------------------------------------------
// Load Super Class

var SoaCollection = require('bunsen/collections/SoaCollection');

// ---------------------------------------------------
// Module Definition

/**
 * Model for data about an item's categories.
 * Sorted by the 'Precedence' field.
 * Uses the {@link ItemCategory} as its model
 * @class ItemCategories
 * @extends SoaCollection
 * @property {function(new:ItemCategory)} ItemCategory
 * @property {string} comparator
 */
var ItemCategories = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var ItemCategory = require('bunsen/models/inventory/ItemCategory');

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemCategories.prototype, /** @lends ItemCategories.prototype */{
    model: ItemCategory,
    comparator: 'precedence',
    /**
     * Return an array of {@link Category} models
     * corresponding to this ItemCategories collection
     * models
     * @returns {Category[]}
     */
    getCategories: function () {
        var categories = [];
        this.each(function (itemCategory) {
            categories.push(itemCategory.getCategory());
        });
        return categories;
    },
    /**
     * Get the category ({@link Category}) at a specified
     * index.
     * @param {number} index
     * @returns {Category}
     */
    getCategoryAt: function (index) {
        var itemCategory = this.at(index);
        if (itemCategory) {
            return itemCategory.getCategory();
        }
    },
    /**
     * @param {number} index
     * @returns {string}
     */
    getCategoryKeyAt: function (index) {
        var itemCategory = this.at(index);
        if (itemCategory) {
            return itemCategory.getCategoryKey();
        }
    },
    /**
     * Return the keys for each category
     * @returns {string[]}
     */
    getCategoryKeys: function () {
        var keys = [];
        this.each(function (itemCategory) {
            keys.push(itemCategory.getCategoryKey());
        });
        return keys;
    },
    /**
     * @param {string} key
     * @returns {ItemCategories}
     */
    removeByCategoryKey: function (key) {
        var itemCategory = this.findByCategoryKey(key);
        if (itemCategory) {
            this.remove(itemCategory);
        }
        return this;
    },
    /**
     * Get the primary item category
     * @returns {ItemCategory}
     */
    getPrimary: function () {
        return this.find(function (itemCategory) {
            return itemCategory.getPrecedence() === 1;
        });
    },
    /**
     * Get the primary item category's {@link Category} key
     * @returns {string}
     */
    getPrimaryCategoryKey: function () {
        var primary = this.getPrimary();
        if (primary) {
            return primary.getCategoryKey();
        }
    },
    /**
     * @param {string} key
     * @returns {ItemCategory}
     */
    findByCategoryKey: function (key) {
        return this.find(function (itemCategory) {
            var category = itemCategory.getCategory();
            return category && category.get('key') === key;
        });
    },
    /**
     * @param {number} precedence
     * @returns {ItemCategory}
     */
    findCategoryByPrecedence : function (precedence) {
        return this.findWhere({ 'precedence' :  precedence }) || this.getPrimary();
    },
    /**
     * @param {string} keys
     * @returns {ItemCategories}
     */
    resetWithKeys: function (keys) {
        this.reset();
        _.each(keys, this.addWithKey, this);
        return this;
    },
    /**
     * Adds an ItemCategory with a category
     * key in increments the precedence of the
     * category
     * @param {string} key
     * @returns {ItemCategories}
     */
    addWithKey : function (key) {
        this.add(this.createWithKey(key));
        return this;
    },
    /**
     * Creates an ItemCategory with a precedence
     * based off of the existing max precedence in
     * the collection
     * @param {string} key
     * @returns {ItemCategory}
     */
    createWithKey: function (key) {
        var precedence = this.getMaxPrecedence() + 1;
        return ItemCategory.createWithKeyAndPrecedence(key, precedence);
    },
    /**
     * Creates an ItemCategory with a category key
     * and a precedence, and adds it to the collection
     * @param {string} key
     * @param {number} precedence
     */
    addWithKeyAndPrecedence: function (key, precedence) {
        this.add(ItemCategory.createWithKeyAndPrecedence(key, precedence));
        return this;
    },
    /**
     * Return the highest value for precedence
     * in the collection
     * @returns {number}
     */
    getMaxPrecedence : function () {
        var lastCategory;
        if (this.length) {
            lastCategory = this.max(function (itemCategory) {
                return itemCategory.getPrecedence() || 0;
            });
        }
        return lastCategory ? lastCategory.getPrecedence() : 0;
    },
    /**
     * @returns {ItemCategories}
     */
    resetPrecedence: function () {
        var precedence = 1;
        this.each(function (itemCategory) {
            itemCategory.set('precedence', precedence);
            precedence++;
        });
        return this;
    }
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/ItemCategories.js
// module id = 2039
// module chunks = 63